// @flow
export const styles: Function = (theme: Object): Object => ({
    sizeSmall: {
        width: '30px !important',
        height: '30px !important',
    },
    sizeMedium: {
        width: '70px !important',
        height: '70px !important',
    },
    sizeBig: {
        width: '110px !important',
        height: '110px !important',
    },
    blueColor: {
        color: '#057AFF'
    }
});


export default styles;
